import React from "react";
import { Header } from "../../header";

export default () => {
  return (
    <div className="e-settings-layout">
      <Header title="Risk reward ratio" showMenu={false}></Header>
      <div className="e-settings-content">
        <p>
          With this strategy builder, you can find the risk reward ratio for
          your own option strategy and decide whether the strategy is worth
          trading or not.
        </p>
        <p>
          Risk reward ratio is the ratio between maximum possible loss and
          maximum possible profit in a trade. It is highly recommended to
          analyze the risk reward ratio before taking a trade whether it is
          futures or options.
        </p>
        <p>
          Avoid a trade if risk reward is 1:1 or less than 1:2. If risk reward
          ratio is 1:2, it means you can recover the loss from two trades with
          profit from a single trade. Similarly, if risk reward ratio is 1:3, it
          means you can recover the loss from three trades with a single trade
          given that the risk in all those trades are same
        </p>
        <p>
          Risk reward ratio of an option trade varies based on the strategy or
          positions. Use the maximum loss and maximum profit values calculated
          by the app to calculate the risk reward ratio of any option strategy
        </p>
        <p>
          Trading in futures has a risk reward ratio of 1:1. It means if there
          is a possibility to earn $1000 in a future trade, then there is also a
          possibility to lose that $1000 in the same trade.
        </p>
        <p>
          Experienced intraday traders manage their risk by placing a stop loss
          based on their risk capacity and hence avoid losing their capital. By
          placing a stop loss and target price, the risk reward ratio can be
          increased to 1:2 or 1:3 in a intraday futures trade.
        </p>

        <p>
          However, this does not apply to swing trading. Because the price can
          change unpredictably and the next day the underlying stock price may
          drop or rise more than our stop loss and we may end up losing more
          than our risk capacity. Hedging futures with options can help you
          mitigate this unexpected risk in swing trading and protect your
          capital from eroding too much when price moves against your position
        </p>
      </div>
    </div>
  );
};
